import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useGroupAdd } from "hooks/citajteo/dl_group/useGroupAdd";
import { QUERY_KEYS } from "constant/react_query";
import DlGroupForm, {
  DlGroupFormState,
} from "components/admin/common/dl_group/DlGroupForm/DlGroupForm";
import toast from "react-hot-toast";

const EMPTY_FORM: DlGroupFormState = {
  slug: "",
  fCondText: "{}",
  groupsText: "",
};

const DlGroupNew: React.FC = () => {
  const navigate = useNavigate();
  const { groupAddMutate } = useGroupAdd({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_GROUP_SEARCH],
  });
  const [form, setForm] = useState<DlGroupFormState>(EMPTY_FORM);
  const [errorText, setErrorText] = useState("");

  const handleChange =
    (field: keyof DlGroupFormState) =>
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setForm((currentForm) => ({
        ...currentForm,
        [field]: event.target.value,
      }));
    };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorText("");

    const trimmedSlug = form.slug.trim();

    if (trimmedSlug === "") {
      setErrorText("Slug ne sme biti prazan.");
      return;
    }

    let parsedFCond: Record<string, string> = {};

    try {
      const rawFCond = form.fCondText.trim();
      parsedFCond = rawFCond === "" ? {} : JSON.parse(rawFCond);
    } catch (error) {
      setErrorText("fCond mora biti ispravan JSON objekat.");
      return;
    }

    if (
      typeof parsedFCond !== "object" ||
      parsedFCond === null ||
      Array.isArray(parsedFCond)
    ) {
      setErrorText("fCond mora biti JSON objekat.");
      return;
    }

    const rawGroups = form.groupsText.trim();
    const parsedGroups =
      rawGroups === ""
        ? []
        : rawGroups
            .split(",")
            .map((groupItem) => groupItem.trim())
            .filter((groupItem) => groupItem !== "");

    groupAddMutate(
      {
        slug: trimmedSlug,
        fCond: parsedFCond,
        groups: parsedGroups,
      },
      {
        onSuccess: () => {
          toast.success("Uspešno dodavanje odrednice.");
          navigate("/admin-dashboard/dl-group-li");
        },
        onError: (error) => {
          console.error("Error adding group:", error);
          toast.error("Greška prilikom dodavanja odrednice.");
        },
      },
    );
  };

  const handleReset = () => {
    setForm(EMPTY_FORM);
    setErrorText("");
  };

  return (
    <FullWidth>
      <div className="App">
        <DlGroupForm
          values={form}
          errorText={errorText}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onReset={handleReset}
        />
      </div>
    </FullWidth>
  );
};

export default DlGroupNew;

const FullWidth = styled.div`
  width: 100%;
`;
